import { getConfigObject, useMutationWithLoading } from "../../utils/utils";
import { PatientInsuranceControllerApi } from "../../services";

export interface updatePatientInsuranceToPrimaryParams {
  patientInsuranceId: string;
  patientUuid: string;
  xTENANTID?: string;
}

export const useUpdatePatientInsuranceToPrimary = () =>
  useMutationWithLoading(
    async (params: updatePatientInsuranceToPrimaryParams) =>
      new PatientInsuranceControllerApi(
        getConfigObject()
      ).updatePatientInsurancePrimary(
        params.patientUuid,
        params.patientInsuranceId,
        params.xTENANTID
      )
  );
